<script>
  import Button from '../common/Button.svelte';
  import StatusBadge from '../common/StatusBadge.svelte';
  
  export let value; // 지원자 객체 (statusOptions 포함)
  export const row = null; // 지원자 객체 (같은 값)
  export const column = null;
  export const index = null;
  
  $: applicant = value;
  $: statusOptions = value?.statusOptions || [];
  
  // 이벤트 디스패처
  import { createEventDispatcher } from 'svelte';
  const dispatch = createEventDispatcher();
  
  function handleStatusChange(event) {
    const newStatus = event.target.value;
    const customEvent = new CustomEvent('statusChange', { 
      detail: { applicant, status: newStatus },
      bubbles: true 
    });
    document.dispatchEvent(customEvent);
  }
  
  function handleViewDetail() {
    const customEvent = new CustomEvent('viewDetail', { 
      detail: applicant,
      bubbles: true 
    });
    document.dispatchEvent(customEvent);
  }
</script>

<div class="applicant-actions">
  <div class="status-section">
    <StatusBadge 
      status={applicant.status === 'reviewing' ? '검토중' : 
             applicant.status === 'proceeding' ? '진행' : 
             applicant.status === 'closed' ? '마감' : 
             applicant.status} 
      variant={applicant.status === 'reviewing' ? 'warning' : 
              applicant.status === 'proceeding' ? 'success' : 
              applicant.status === 'closed' ? 'default' : 'primary'}
    />
    
    <select 
      value={applicant.status}
      on:change={handleStatusChange}
      class="status-select"
    >
      {#each statusOptions as option}
        <option value={option.id}>{option.label}</option>
      {/each}
    </select>
  </div>
  
  <Button 
    variant="secondary" 
    size="sm"
    on:click={handleViewDetail}
  >
    상세
  </Button>
</div>

<style>
  .applicant-actions {
    display: flex;
    flex-direction: column;
    gap: var(--spacing-sm);
    align-items: center;
  }
  
  .status-section {
    display: flex;
    flex-direction: column;
    gap: var(--spacing-xs);
    align-items: center;
  }
  
  .status-select {
    padding: var(--spacing-xs) var(--spacing-sm);
    border: 1px solid var(--border-color);
    border-radius: var(--border-radius-sm);
    font-size: var(--font-size-sm);
    background: var(--color-white);
    min-width: 100px;
  }
  
  @media (max-width: 768px) {
    .applicant-actions {
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
    }
    
    .status-section {
      flex-direction: column;
    }
  }
</style> 